import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IQuestionWidget } from './IQuestionWidget.ts';
import { QuestionTitle } from './style/QuestionTitle.tsx';

export interface IQuestionWidgetComponentProps
  extends IWidgetComponentProps<IQuestionWidget> {}

export function QuestionWidgetComponent(props: IQuestionWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <>
      <QuestionTitle
        title={widget.title}
        description={
          widget.layout?.hideDescription ? undefined : widget.description
        }
      />
      {props.children}
    </>
  );
}
